import { render, staticRenderFns } from "./DuplicateReferralModal.vue?vue&type=template&id=787599ce&"
import script from "./DuplicateReferralModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateReferralModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports